import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { TealiumEvent } from 'src/components/AnalyticsProvider/AnalyticsProvider';
import { useSendAnalytics } from 'src/components/AnalyticsProvider/useSendAnalytics';
import {
  CSVUploadStatus,
  getUniqueAndSortedErrors,
  UploadStatus,
} from 'src/components/CSVUploadTracking/CSVUploadTracking.utils';

export interface UseAddNewPeopleCSVModalAnalytics {
  sendAnalyticsByUploadStatus: (uploadStatus: UploadStatus) => void;
}

export const useAddNewPeopleCSVModalAnalytics =
  (): UseAddNewPeopleCSVModalAnalytics => {
    const { locId } = useParams<{ locId: string }>();

    const { sendAnalytics } = useSendAnalytics({
      eventcategory: 'self-service management tool_people',
      eventaction: locId ? 'loc_upload csv' : 'add people_upload csv',
      eventlabel: '',
    });

    useEffect(() => {
      sendAnalytics({
        eventaction: locId ? 'loc_csv_impression' : 'csv_impression',
        eventlabel: 'success',
      });
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [locId]);

    return {
      sendAnalyticsByUploadStatus: (uploadStatus) =>
        sendTealiumEventByUploadStatus(sendAnalytics, uploadStatus),
    };
  };

export function sendTealiumEventByUploadStatus(
  sendAnalytics: (evenData: Pick<TealiumEvent, 'eventlabel'>) => void,
  uploadStatus: UploadStatus
): void {
  switch (uploadStatus.status) {
    case CSVUploadStatus.COMPLETE: {
      sendAnalytics({ eventlabel: `${uploadStatus.totalRecords}` });
      break;
    }
    case CSVUploadStatus.ERROR: {
      sendAnalytics({
        eventlabel: getUniqueAndSortedErrors(uploadStatus.lineErrors).join(','),
      });
      break;
    }
    case CSVUploadStatus.FILE_ERROR: {
      sendAnalytics({
        eventlabel: getUniqueAndSortedErrors(uploadStatus.fileErrors).join(','),
      });
      break;
    }
    default: {
      break;
    }
  }
}
